import script from "./StopDocumentsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StopDocumentsTab.vue?vue&type=script&setup=true&lang=js"

import "./StopDocumentsTab.vue?vue&type=style&index=0&id=c8f6662e&scoped=true&lang=css"
import "./StopDocumentsTab.vue?vue&type=style&index=1&id=c8f6662e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f6662e"]])

export default __exports__